<template>
    <div>
        <a-select
                showSearch
                v-model="model"
                :placeholder="placeholder"
                :defaultActiveFirstOption="false"
                :filterOption="false"
                @search="handleSearch"
                @change="handleChange"
                :notFoundContent="null"
                style="width: 160px"
        >
            <a-select-option v-for="option in options" :key="option.id" :value="option.id">{{option.title}}
            </a-select-option>
        </a-select>
    </div>

</template>
<script>
    import {getGoodsOptions} from '@/api/goods';

    export default {
        name: 'GoodsPicker',
        data() {
            return {
//        model:undefined,
                options: [],
                goods_id: 0
            }
        },
        props: {
            formData: {
                type: Object,
                required: true
            },
            field: {
                type: String | Number,
                required: true
            },
            fieldDisplay: {
                type: String | Number,
                required: true
            },
            placeholder: {
                type: String,
                default: '请选择商品'
            },
            goodsType: {
                type: String,
                default: ''
            }
        },
        computed: {
            model: {
                get: function () {
                    return this.formData[this.field];
                },
                set: function () {
                }
            }
        },
        watch: {
        },
        created() {
            let that = this;
            if (that.formData[this.field] > 0) {
                that.options = [
                    {
                        title: that.formData[this.fieldDisplay],
                        id: that.formData[this.field],
                    }
                ]
            }

        },
        methods: {
            handleSearch(value) {
                let that = this;
                getGoodsOptions({keywords: value, type: that.goodsType}).then(res => {
                    that.options = res.data
                })
            },
            handleChange(value, options) {
                let that = this;
                this.formData[this.field] = value;
                let selected = that.options.filter((item) => {
                    return item.id == value
                })
                console.log('selected', selected);
                this.formData[this.fieldDisplay] = selected[0].title;

                that.$emit('getGoodsid', value);
            }
        },
    }
</script>
<style>

</style>